export const getApps = state => state.apps;
